import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentSection, Quote } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import React from "react";
import renderWithResolver from "../../rich-text-renderer/rich-text-renderer";
export var RichTextSection = function(blok) {
    if (Object.keys(blok).length === 0) {
        return null;
    }
    var title = blok.title, body = blok.body, quote = blok.quote;
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        children: [
            /*#__PURE__*/ _jsx(ContentSection, {
                classNames: {
                    body: "storyblokRichTextBody"
                },
                title: title || "",
                children: renderWithResolver(body)
            }),
            quote ? /*#__PURE__*/ _jsx(Quote, {
                text: quote
            }) : null
        ]
    }));
};
export default RichTextSection;
